import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Card } from "@mui/material/";
import { QueryAPI } from "API/QueryAPI";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { checkResponse } from "helpers/notification";
import React from "react"
import { v4 as uuidv4 } from 'uuid';
import CustomExport from "components/CustomExport";
import Moment from 'moment';
import { useLocation } from "react-router-dom";
import { style } from "style";
import { setIsDailyReportExport } from "features/commonSlice";
import moment from 'moment';
import AlertNoRecordFound from "components/AlertNoRecordFound";

function DailyReportDetail(props) {

    // consts
    const location = useLocation();
    const { queryId, requestParameters } = location.state || {};
    const [list, setList] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [columnsMMS, setColumnsMMS] = useState([]);
    const [rowsMMS, setRowsMMS] = useState([]);
    const [listMMS, setListMMS] = useState([]);
    const [listHedef, setListHedef] = useState([]);
    const [columnsHedef, setColumnsHedef] = useState([]);
    const [rowsHedef, setRowsHedef] = useState([]);
    const numberFormatter = new Intl.NumberFormat('tr-TR');

    const isDailyReportExport = useSelector(state => state.common.isDailyReportExport);
    var authorization = useSelector(state => state.common.authorization);
    var appId = useSelector(state => state.common.appId);
    var sessionId = useSelector(state => state.common.sessionId);
    var userName = useSelector(state => state.common.userName);

    const dispatch = useDispatch();

    // functions
    const getQueryData = async () => {
        const getQueryDataResponse = await QueryAPI.GetQueryData(queryId, "dailyreport");

        if (checkResponse(getQueryDataResponse, null, "Detay Rapor getirme işlemi başarısız oldu")) {
            let res = getQueryDataResponse.data.resultObject;

            setList(res.bulkSmsReports);
            setListMMS(res.mmsReport);
            setListHedef(res.hedefDailyReport);
        }
    };

    useEffect(() => {
        getQueryData();
    }, [queryId]);

    useEffect(() => {
        const createRowsAndColumns = () => {
            const rowsData = [];
            if (list.length > 0) {
                list.map(data =>
                    rowsData.push({
                        id: uuidv4(),
                        smsAPI: data.smsAPI,
                        smsType: data.smsType,
                        paymentType: data.paymentType,
                        sum_SentCnt: numberFormatter.format(data.sum_SentCnt),
                        sum_DeliveryCnt: numberFormatter.format(data.sum_DeliveryCnt),
                        sum_UnsentCnt: numberFormatter.format(data.sum_UnsentCnt),
                        sum_WaitCnt: numberFormatter.format(data.sum_WaitCnt),
                        sum_Contor: numberFormatter.format(data.sum_Contor),
                        day: data.day,
                    })
                );
            }
            setRows(rowsData);
            setColumns([
                {
                    headerName: "id", field: "id", flex: 0, hide: true, disableExport: true,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.id}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Sms API", field: "smsAPI", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.smsAPI}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Sms Türü", field: "smsType", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.smsType}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Hesap Türü", field: "paymentType", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.paymentType}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Toplam", field: "sum_SentCnt", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_SentCnt}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "İletilen", field: "sum_DeliveryCnt", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_DeliveryCnt}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "İletilmeyen", field: "sum_UnsentCnt", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_UnsentCnt}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Beklemede", field: "sum_WaitCnt", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_WaitCnt}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Kontör", field: "sum_Contor", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_Contor}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Gün", field: "day", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.day}
                            </MDTypography>
                        );
                    }
                },
            ]);
        };
        createRowsAndColumns();
    }, [list]);

    useEffect(() => {
        const createRowsAndColoumns = async e => {
            const rowsDataMMS = [];
            if (listMMS.length > 0) {
                listMMS.map(data =>
                    rowsDataMMS.push({
                        id: uuidv4(),
                        smsAPI: data.smsAPI,
                        customerName: data.customerName,
                        day: data.day,
                        suM_TotalMessageCount: numberFormatter.format(data.suM_TotalMessageCount),
                        suM_TotalDelivered: numberFormatter.format(data.suM_TotalDelivered),
                        suM_TotalUndelivered: numberFormatter.format(data.suM_TotalUndelivered),
                        suM_TotalWaiting: numberFormatter.format(data.suM_TotalWaiting),
                        suM_TotalErrored: numberFormatter.format(data.suM_TotalErrored),
                        statu: data.statu,
                    })
                );

            }
            setRowsMMS(rowsDataMMS);
            setColumnsMMS([
                {
                    headerName: "id", field: "id", flex: 0, hide: true, disableExport: true,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.id}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Sms API", field: "smsAPI", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.smsAPI}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Müşteri Adı", field: "customerName", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.customerName === null ? "" : params.row.customerName}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Toplam", field: "suM_TotalMessageCount", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.suM_TotalMessageCount}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "İletilen", field: "suM_TotalDelivered", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.suM_TotalDelivered}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "İletilmeyen", field: "suM_TotalUndelivered", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.suM_TotalUndelivered}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Beklemede", field: "suM_TotalWaiting", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.suM_TotalWaiting}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Hatalı", field: "suM_TotalErrored", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.suM_TotalErrored}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Durum", field: "statu", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.statu}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Gün", field: "day", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.day}
                            </MDTypography>
                        );
                    }
                },
            ]);
        };
        createRowsAndColoumns();
    }, [listMMS]);

    useEffect(() => {
        const createRowsAndColoumns = async e => {
            const rowsDataHedef = [];
            if (listHedef.length > 0) {
                listHedef.map(data =>
                    rowsDataHedef.push({
                        id: uuidv4(),
                        smsAPI: data.smsAPI,
                        paymentType: data.paymentType,
                        sum_MatchesCount: numberFormatter.format(data.sum_MatchesCount),
                        sum_Push_limit: numberFormatter.format(data.sum_Push_limit),
                        sum_Delivered: numberFormatter.format(data.sum_Delivered),
                        sum_NotDelivered: numberFormatter.format(data.sum_NotDelivered),
                        day: data.Day,
                    })
                );
            }
            setRowsHedef(rowsDataHedef);
            setColumnsHedef([
                {
                    headerName: "id", field: "id", flex: 0, hide: true, disableExport: true,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.id}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Sms API", field: "smsAPI", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.smsAPI}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "	Ödeme Tipi", field: "paymentType", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.paymentType}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "	Toplam Eşleşen Adet", field: "sum_MatchesCount", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_MatchesCount}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "	Toplam Gönderilen Adet", field: "sum_Push_limit", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_Push_limit}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "İletilen", field: "sum_Delivered", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_Delivered}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "	İletilmeyen", field: "sum_NotDelivered", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.sum_NotDelivered}
                            </MDTypography>
                        );
                    }
                },
                {
                    headerName: "Gün", field: "day", flex: 1,
                    renderCell: params => {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.day}
                            </MDTypography>
                        );
                    }
                },
            ]);
        };
        createRowsAndColoumns();
    }, [listHedef]);

    //const selectedFileName = `Tüm Firmalar Günlük Rapor${new Date().toISOString().slice(0, 19).replace('T', '').replace(/-/g, '').replace(/:/g, '')}.xlsx`;;
    const selectedFileName = `Tüm Firmalar Günlük Rapor${moment().format('YYYYMMDDHHmmss')}.xlsx`;
    const exportToExcel = async () => {


        var reqPar = JSON.parse(requestParameters)
        var startDate = reqPar.startDate;
        var endDate = reqPar.endDate;

        const response = await fetch(
            process.env.REACT_APP_API_ROOT + `/DailyReport/DailyReportExcel/download?queryId=` + queryId,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: authorization,
                    AppId: appId,
                    SessionId: sessionId
                },
            });

        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', selectedFileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        window.dispatchEvent(new Event("backdropOpenEndEvent"));
    };

    useEffect(() => {
        if (isDailyReportExport) {
            exportToExcel();
            dispatch(setIsDailyReportExport(false));
        }
    }, [isDailyReportExport]);

    useEffect(() => {
        const onRefresh = async () => {
            await getQueryData();
        };

        window.addEventListener("pageRefreshRequested", onRefresh);
        return () => window.removeEventListener("pageRefreshRequested", onRefresh);
    }, [queryId]);


    return (
        <DashboardLayout>
            <DashboardNavbar />

            {rows.length > 0 ?
                <MDBox pt={3} pb={1}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={1}
                                    px={2}
                                    variant='gradient'
                                    bgColor='info'
                                    borderRadius='lg'
                                    coloredShadow='info'
                                >
                                    <MDTypography variant='h6' color='white'>
                                        Günlük Rapor
                                    </MDTypography>
                                    <MDTypography style={{ fontSize: "13px" }} color='white'>
                                        Bulk ve Fast sms rapor sonuçları aşağıdaki gibidir.
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={3}>
                                    <CustomExport
                                        rows={rows}
                                        columns={columns}
                                        exportFileName={userName
                                            + "_GunlukRapor_"
                                            + Moment(new Date()).format('YYYYMMDDHHmmss').toString()}
                                    />
                                </MDBox>


                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                :
                <AlertNoRecordFound />
            }

            {rowsMMS.length > 0 ?
                <MDBox pt={3} pb={1}>
                    <Grid container spacing={6}>
                        <Grid item xs={12} mt={4}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={1}
                                    px={2}
                                    variant='gradient'
                                    bgColor='info'
                                    borderRadius='lg'
                                    coloredShadow='info'
                                >
                                    <MDTypography variant='h6' color='white'>
                                        Günlük MMS Rapor
                                    </MDTypography>
                                    <MDTypography style={{ fontSize: "13px" }} color='white'>
                                        Günlük MMS rapor sonuçları aşağıdaki gibidir.
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={3}>
                                    {rowsMMS.length > 0 ? (
                                        <CustomExport
                                            rows={rowsMMS}
                                            columns={columnsMMS}
                                            exportFileName={userName +
                                                "_GunlukRaporMMS_" +
                                                Moment(new Date()).format('YYYYMMDDHHmmss').toString()}
                                        />
                                    ) : (
                                        <MDTypography style={{ fontSize: "16px", paddingTop: "8px", textAlign: "center" }} color='textPrimary'>
                                            Herhangi bir rapor sonucu bulunamamıştır.
                                        </MDTypography>
                                    )}
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                : <AlertNoRecordFound />}

            {rowsHedef.length > 0 ?
                <MDBox pt={3} pb={1}>
                    <Grid container spacing={6}>
                        <Grid item xs={12} mt={4}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={1}
                                    px={2}
                                    variant='gradient'
                                    bgColor='info'
                                    borderRadius='lg'
                                    coloredShadow='info'
                                >
                                    <MDTypography variant='h6' color='white'>
                                        Günlük Hedefli Rapor
                                    </MDTypography>
                                    <MDTypography style={{ fontSize: "13px" }} color='white'>
                                        Günlük Hedefli rapor sonuçları aşağıdaki gibidir.
                                    </MDTypography>
                                </MDBox>
                                <MDBox pt={3}>
                                    {rowsHedef.length > 0 ? (
                                        <CustomExport
                                            rows={rowsHedef}
                                            columns={columnsHedef}
                                            exportFileName={userName +
                                                "_GunlukRaporHedef_" +
                                                Moment(new Date()).format('YYYYMMDDHHmmss').toString()}
                                        />
                                    ) : (
                                        <MDTypography style={{ fontSize: "16px", paddingTop: "8px", textAlign: "center" }} color='textPrimary'>
                                            Herhangi bir rapor sonucu bulunamamıştır.
                                        </MDTypography>
                                    )}
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                : <AlertNoRecordFound />}

        </DashboardLayout>
    );
}

export default DailyReportDetail;